<template>
  <CardTmpl :space="call.Space">
    <template slot="header">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon dark v-on="on" class="mr-1">mdi-car-brake-parking</v-icon>
          <span class="ml-2 title-space white--text" v-on="on"> {{ call.Space }} </span>
        </template>
        <span>{{ $t('parking.tooltip.space') }} {{ call.Space }}</span>
      </v-tooltip>
      <v-spacer />
      <v-icon small dark class="mr-1">mdi-timer-outline</v-icon>
      <span class="parked-time white--text text-caption"> {{ parkedTime | formatTime }} </span>
    </template>

    <v-row slot="content">
      <v-col md="12">
        <table>
          <div class="d-flex justify-start mb-4">
            <v-list-item-avatar class="ma-0 mr-1">
              <v-img
                v-if="displayParkee.hasImage"
                :src="displayParkee.imageUrl"
                :alt="displayParkee.name"
                data-testid="parking-parkee-avatar"
              ></v-img>
              <v-img
                v-else
                src="/default_picture_profile.png"
                :alt="displayParkee.name"
                data-testid="parking-parkee-defaultPicture"
              ></v-img>
            </v-list-item-avatar>
            <div>
              <tr class="parked-call-username">
                <td class="text-no-wrap field-head">
                  {{ displayParkee.name }}
                </td>
              </tr>
              <tr class="parked-call-number">
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div class="text-no-wrap text-truncate text-caption field-value ml-1" v-on="on">
                        {{ displayParkee.phoneNumber | formatPhoneNum(countryCode) }}
                      </div>
                    </template>
                    <span> {{ displayParkee.phoneNumber | formatPhoneNum(countryCode) }} {{ displayParkee.name }} </span>
                  </v-tooltip>
                </td>
              </tr>
            </div>
          </div>
          <tr class="parked-by">
            <td class="text-no-wrap field-head">
              <v-icon small class="mr-2">mdi-account-tie</v-icon>
              {{ $t('parking.label.parkedBy') }}
            </td>
          </tr>
          <tr class="parked-by-value">
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="text-no-wrap text-truncate field-username ml-1" v-on="on">
                    {{ call.ParkerName || call.ParkerNum | formatPhoneNum(countryCode) }}
                  </div>
                  <div class="text-no-wrap text-truncate text-caption field-number ml-1 mb-2" v-on="on">
                    {{ call.ParkerNum | formatPhoneNum(countryCode) }}
                  </div>
                </template>
                <span> {{ call.ParkerNum | formatPhoneNum(countryCode) }} {{ call.ParkerName }} </span>
              </v-tooltip>
            </td>
          </tr>
          <tr class="parked-at">
            <td class="text-no-wrap field-head">
              <v-icon small class="mr-2">mdi-clock-start</v-icon>
              {{ $t('parking.label.parkedAt') }}
            </td>
          </tr>
          <tr class="parked-at-value">
            <td class="field-value"><span class="ml-1 text-no-wrap text-truncate">{{ startedAt }}</span></td>
          </tr>
        </table>
      </v-col>
    </v-row>

    <template slot="actions">
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn @click="parkRetrv" v-on="on" fab
            x-small dark depressed color="primary">
            <v-icon>mdi-phone-return</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('parking.tooltip.retrieveCall') }} {{ call.Space }}</span>
      </v-tooltip>
      <v-spacer />
    </template>
  </CardTmpl>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardTmpl from './card_tmpl'
export default {
  name: 'parking-call-card',
  components: { CardTmpl },
  data () {
    return {
      parkedTime: 0
    }
  },
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  timer: 'timeUpdate',
  mounted () {
    this.parkedTime = (Date.now() - this.call.started) / 1000
  },
  computed: {
    ...mapGetters({
      countryCode: 'countryCode',
      phoneNumbers: 'contacts/phoneNumbers/phoneNumbers'
    }),
    startedAt: function () {
      if (!this.call.started) {
        return ''
      }
      const _supportedLocales = Intl.DateTimeFormat.supportedLocalesOf([this.$i18n.locale])
      const dateObj = new Intl.DateTimeFormat(_supportedLocales.length ? this.$i18n.locale : 'en-US', { timeStyle: 'medium' })
      return dateObj.format(this.call.started)
    },
    contact () {
      return this.phoneNumbers?.find((phone) => parseInt(phone.phoneNumber) === parseInt(this.call?.ParkeeNum))
    },
    displayParkee () {
      if (this.contact) {
        return this.contact
      } else {
        return {
          hasImage: false,
          name: this.call?.ParkeeName,
          imageUrl: null,
          phoneNumber: this.call?.ParkeeNum
        }
      }
    }
  },
  methods: {
    ...mapActions({ callNumber: 'callNumber' }),
    timeUpdate: function () {
      this.parkedTime++
    },
    parkRetrv: function () {
      this.callNumber({ number: this.call.Space })
    }
  }
}
</script>

<style scoped>
.field-head {padding: 1px 4px;font-weight: 500; width:120px}
.field-value {width:220px}
.field-username {width:220px}
.field-number {width:220px}
</style>
